import { render, staticRenderFns } from "./CdnImg.vue?vue&type=template&id=531129bf&"
import script from "./CdnImg.vue?vue&type=script&lang=js&"
export * from "./CdnImg.vue?vue&type=script&lang=js&"
import style0 from "./CdnImg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports